import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router';
import classNames from 'classnames';
// translate
import messages from './messages';

class Approve extends Component {
  constructor(props) {
    super(props);

    this.onChangeStatus = this.onChangeStatus.bind(this);

    this.state = Object.assign({
      status: true,
    });
  }

  onChangeStatus() {
    this.setState({
      status: !this.state.status,
    });
  }

  render() {
    const { intl, onApproved, onClose } = this.props;
    return (
      <div className="popup-wrap" style={{ display: 'block' }}>
        <div className="popup-reg-wrap login-wrap active">
          <div className="popup-reg-inner">
            <div className="popup-reg">
              <p className="popup-header">
                {intl.formatMessage(messages.header)}
              </p>

              <div className="popup-body">
                <div>
                  <form className="popup-form" method="post">
                    <div className="label">
                      <label className="checkbox-wrap" htmlFor="remember">
                        <span
                          role="button"
                          tabIndex="0"
                          onClick={this.onChangeStatus}
                          className={classNames('checkbox', {
                            checked: this.state.status,
                          })}
                        >
                          <input
                            type="checkbox"
                            name="status"
                            value="1"
                            onChange={this.onChangeStatus}
                            checked={this.state.status}
                          />
                        </span>
                        <span>
                          <FormattedHTMLMessage {...messages.terms} />
                        </span>
                      </label>
                    </div>

                    {this.state.status &&
                      <button
                        className="trans"
                        onClick={onApproved}
                        type="button"
                      >
                        {intl.formatMessage(messages.submitButton)}
                      </button>}
                  </form>
                </div>
              </div>

              <Link className="popup-close trans" onClick={onClose} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Approve.propTypes = {
  intl: intlShape.isRequired,
  onClose: PropTypes.func.isRequired,
  onApproved: PropTypes.func.isRequired,
};

export default injectIntl(Approve);



// WEBPACK FOOTER //
// ./src/components/Approve/index.js